import "core-js/modules/es.array.push.js";
import { useChatAuthorization } from "@faire/help-center-self-serve/chat/hooks/useChatAuthorization";
import { EmailUs } from "@faire/help-center-self-serve/components/EmailUs";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { trackHelpCenterPhoneClick } from "@faire/web-api/events/helpCenter/click/phone";
import { trackHelpCenterPhoneOverChatClick } from "@faire/web-api/events/helpCenter/click/phoneOverChat";
import { Column, Flex, Row } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { useIssueType } from "../../hooks/useIssueType";
import { useSelectedNodeAnswer } from "../../hooks/useSelectedNodeAnswer";
import { isPhoneInBusinessHours } from "../Phone/isPhoneInBusinessHours";
import { usePhoneAuthorization } from "../Phone/usePhoneAuthorization";
import { selfServePageToStepAndRoute, StepPage } from "../step";
import { ChatButton } from "./ChatButton";
import { trackEmailUsClickWhenChatInBusinessHours } from "./events/trackEmailUsClickWhenChatInBusinessHours";
import { trackEmailUsClickWhenPhoneInBusinessHours } from "./events/trackEmailUsClickWhenPhoneInBusinessHours";
import { LiveChatUnavailable } from "./LiveChatUnavailable";
import { PhoneButton } from "./PhoneButton";
export var ContactOptions = function ContactOptions(_ref) {
  var _getRetailerToken, _getBrandToken;
  var loadTimingRef = _ref.loadTimingRef,
    hasDescription = _ref.hasDescription;
  var retailerToken = (_getRetailerToken = getRetailerToken()) !== null && _getRetailerToken !== void 0 ? _getRetailerToken : "";
  var brandToken = (_getBrandToken = getBrandToken()) !== null && _getBrandToken !== void 0 ? _getBrandToken : "";
  var _useIssueType = useIssueType(),
    issueType = _useIssueType.issueType;
  var history = useHistory();
  var _useSelectedNodeAnswe = useSelectedNodeAnswer(),
    hasInstantAnswer = _useSelectedNodeAnswe.hasInstantAnswer,
    hasHelpArticles = _useSelectedNodeAnswe.hasHelpArticles;
  var _useChatAuthorization = useChatAuthorization(),
    hasChatAccess = _useChatAuthorization.hasChatAccess,
    isChatInBusinessHours = _useChatAuthorization.isChatInBusinessHours,
    isChatInHolidayMode = _useChatAuthorization.isChatInHolidayMode;
  var _usePhoneAuthorizatio = usePhoneAuthorization(),
    hasPhoneAccess = _usePhoneAuthorizatio.hasPhoneAccess;
  var trackClick = function trackClick() {
    trackEmailUsClickWhenChatInBusinessHours(issueType, !isChatInBusinessHours || isChatInHolidayMode);
    trackEmailUsClickWhenPhoneInBusinessHours(issueType, hasPhoneAccess);
  };
  var callRequestOnClick = function callRequestOnClick() {
    history.push(selfServePageToStepAndRoute[StepPage.PHONE_FORM].route);
    if (isChatInBusinessHours && !isChatInHolidayMode) {
      trackHelpCenterPhoneOverChatClick(retailerToken, brandToken, issueType);
    }
    trackHelpCenterPhoneClick(retailerToken, brandToken);
  };
  var renderPhoneChatEmail = function renderPhoneChatEmail() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, hasPhoneAccess ? ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PhoneButton, {
      onClick: callRequestOnClick
    }), /*#__PURE__*/React.createElement(Spacer, {
      width: "2x"
    }))) : null, /*#__PURE__*/React.createElement(ChatButton, null), /*#__PURE__*/React.createElement(LiveChatUnavailable, null), hasChatAccess ? /*#__PURE__*/React.createElement(Spacer, {
      width: "2x"
    }) : null, /*#__PURE__*/React.createElement(EmailUs, {
      to: selfServePageToStepAndRoute[StepPage.EMAIL_FORM].route,
      onClick: trackClick
    }));
  };
  var renderPhoneEmailChat = function renderPhoneEmailChat() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, hasPhoneAccess ? ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PhoneButton, {
      onClick: callRequestOnClick
    }), /*#__PURE__*/React.createElement(Spacer, {
      width: "2x"
    }))) : null, /*#__PURE__*/React.createElement(EmailUs, {
      to: selfServePageToStepAndRoute[StepPage.EMAIL_FORM].route,
      onClick: trackClick
    }), /*#__PURE__*/React.createElement(Spacer, {
      width: "2x"
    }), /*#__PURE__*/React.createElement(ChatButton, null), /*#__PURE__*/React.createElement(LiveChatUnavailable, null));
  };
  var renderEmailChatPhone = function renderEmailChatPhone() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EmailUs, {
      to: selfServePageToStepAndRoute[StepPage.EMAIL_FORM].route,
      onClick: trackClick
    }), /*#__PURE__*/React.createElement(Spacer, {
      width: "2x"
    }), /*#__PURE__*/React.createElement(ChatButton, null), /*#__PURE__*/React.createElement(LiveChatUnavailable, null), hasPhoneAccess ? ( /*#__PURE__*/React.createElement(React.Fragment, null, hasChatAccess ? /*#__PURE__*/React.createElement(Spacer, {
      width: "2x"
    }) : null, /*#__PURE__*/React.createElement(PhoneButton, {
      onClick: callRequestOnClick
    }))) : null);
  };
  var renderChatEmailPhone = function renderChatEmailPhone() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ChatButton, null), /*#__PURE__*/React.createElement(LiveChatUnavailable, null), hasChatAccess ? /*#__PURE__*/React.createElement(Spacer, {
      width: "2x"
    }) : null, /*#__PURE__*/React.createElement(EmailUs, {
      to: selfServePageToStepAndRoute[StepPage.EMAIL_FORM].route,
      onClick: trackClick
    }), hasPhoneAccess ? ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
      width: "2x"
    }), /*#__PURE__*/React.createElement(PhoneButton, {
      onClick: callRequestOnClick
    }))) : null);
  };
  var renderChatAndPhone = function renderChatAndPhone() {
    if (!isChatInBusinessHours && !isPhoneInBusinessHours()) {
      return renderEmailChatPhone();
    }
    if (!isChatInBusinessHours && isPhoneInBusinessHours()) {
      return renderPhoneEmailChat();
    }
    if (isChatInBusinessHours && !isPhoneInBusinessHours()) {
      return renderChatEmailPhone();
    }
    return renderPhoneChatEmail();
  };
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(ContactUsTitleAndDescription, {
    hasDescription: hasDescription,
    fontIncrease: !hasHelpArticles && !hasInstantAnswer
  }), /*#__PURE__*/React.createElement(ContactUsWrapper, {
    ref: loadTimingRef
  }, renderChatAndPhone()));
};
var ContactUsTitleAndDescription = function ContactUsTitleAndDescription(_ref2) {
  var hasDescription = _ref2.hasDescription,
    fontIncrease = _ref2.fontIncrease;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: fontIncrease ? "sectionHeaderSansMedium" : "subheadingSansMedium"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "WnQ/AZ",
    defaultMessage: "Contact us"
  })), hasDescription ? ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(SubtitleWrapper, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "qEl/jE",
    defaultMessage: "Our support team will be happy to help. We\u2019ll provide them all the info you\u2019ve shared already."
  }))))) : null, /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }));
};
var ContactUsWrapper = styled(Flex).attrs({
  direction: {
    desktopAndAbove: "row",
    mobileAndAbove: "column"
  }
}).withConfig({
  displayName: "ContactOptions__ContactUsWrapper"
})(["", "{width:100%;}"], responsiveMediaQueries.tabletAndBelow);
var SubtitleWrapper = styled(Row).withConfig({
  displayName: "ContactOptions__SubtitleWrapper"
})(["margin-bottom:", ";width:100%;"], getSpacing("2x"));